import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import Router from 'vue-router'
import Home from '@/views/home/Home'
import Master from '@/views/master/Master'
import Taekwondo from '@/views/taekwondo/Taekwondo'
import CarouselImages from '@/views/carousel-images/carousel-images'
import Exams from '@/views/exams/Exams'
import Learning from '@/views/learning/Learning'

Vue.use(Router)
Vue.use(Vue2TouchEvents)

export default new Router({
	routes: [{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/master-nam-san',
			name: 'master',
			component: Master
		}, {
			path: '/taekwondo',
			name: 'taekwondo',
			component: Taekwondo
		},
		{
			path: '/carousel-images/:numberPhotos/:labelImageToShow',
			component: CarouselImages,
			props: true
		}, {
			path: '/exams',
			name: 'exams',
			component: Exams
		}, {
			path: '/learning',
			name: 'learning',
			component: Learning
		}
	]
})
